module.exports = __webpack_public_path__ + "img/rule-4.4429eba2.png";